module.exports = __webpack_public_path__ + "media/images/client-right-at-home-96e140dada7b35d3ea44d051a2601623.png";